import React, { memo } from 'react';
import {    getRessouresUrl, 
            ellipsify, 
            prettyPrintDate,
            prettyPrintCategory,
            cleanDisplayFilename } from './../../../utils/config';
import PublicationModal from './PublicationModal';
import PdfViewerModal from './../../../components/pdf-viewer/PdfViewerModal';
import ImageGallery from 'react-image-gallery';

import './../../../assets/css/image-gallery.scss';
import './../../../assets/css/style.css';

const PublicationCard = (props) => {
    const publication = props.data;
    const category = props.category;

    return (
        <div className="custom-card viewer card-publication card-shadow">
            <div className="text-container">
                {/* Title */}
                <h3>
                    { publication.title }
                </h3>
                <hr />
                <div className="mt-2 pb-4">
                    {/* Publication category */}
                    {
                        category
                        ?   <span className="p-tiny-text">
                                <b>
                                    {prettyPrintCategory(category)}&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp; 
                                </b>
                            </span>
                        : null
                    }
                    {/* Publication date */}
                    <span className="p-tiny-text">
                        <b>
                            Published on {prettyPrintDate(publication.publicationDate)}
                        </b>
                    </span>
                </div>
                {/* Description */}
                <p className="p-reading-text pt-2 pb-2">
                    { publication.description }
                </p>
                {/* Uploaded documents and files */}
                {
                    publication.publicationDocs.length !== 0
                    ?   <div key={publication._id+publication.title+"docs"} className="pt-4">
                            <span className="p-tiny-text">
                                <b>
                                    {prettyPrintCategory(publication.category) + " documents"}
                                </b>
                            </span>
                            {publication.publicationDocs.map((doc, index) => (
                                <div key={cleanDisplayFilename(doc)+index}>
                                    <PdfViewerModal btnPrompt={cleanDisplayFilename(doc)}
                                                    modalPrompt={cleanDisplayFilename(doc)} 
                                                    ressource={getRessouresUrl()+doc}/>
                                    {index !== (publication.publicationDocs.length-1)
                                        ? <span className="pt-4"></span>
                                        : null
                                    }
                                </div>
                            ))}
                        </div>
                    : null
                }
                {/* Links and ressources */}
                {
                    publication.links.filter(data => !data.display.toLowerCase().includes('listen')).length !== 0
                    ?   <>
                            <p className="p-tiny-text pt-4">
                                <b>
                                    Links and ressources
                                </b>
                            </p>
                            {publication.links.filter(data => !data.display.toLowerCase().includes('listen')).map((data, index) => (
                                <span key={data.link+index} className="custom-span-text">
                                    <a  target="_blank" 
                                        rel="noreferrer" 
                                        draggable={false}
                                        href={data.link} >
                                            {data.display
                                                ? data.display
                                                : ellipsify(data.link)
                                            }
                                    </a>    
                                    {index !== (publication.links.filter(data => !data.display.toLowerCase().includes('listen')).length-1)
                                        ? <span className="custom-span-text">, </span>
                                        : null
                                    }
                                </span>))}
                        </>
                    : null
                }
                {/* Links and ressources that contain the word listen (podcast testing phase) */}
                {
                    publication.links.filter(data => data.display.toLowerCase().includes('listen')).length !== 0
                    ?   <>
                            <p className="p-tiny-text pt-4">
                                <b>
                                    Podcast format
                                </b>
                            </p>
                            {publication.links.filter(data => data.display.toLowerCase().includes('listen')).map((data, index) => (
                                <span key={data.link+index} className="custom-span-text">
                                    <a  target="_blank" 
                                        rel="noreferrer" 
                                        draggable={false}
                                        href={data.link} >
                                            {data.display
                                                ? data.display
                                                : ellipsify(data.link)
                                            }
                                    </a>    
                                    {index !== (publication.links.filter(data => data.display.toLowerCase().includes('listen')).length-1)
                                        ? <span className="custom-span-text">, </span>
                                        : null
                                    }
                                </span>))}
                        </>
                    : null
                }
                {/* Uploaded images */}
                {
                    publication.publicationImages.length !== 0
                    ? <>
                        <br />
                        <ImageGallery items={
                            publication.publicationImages.map(img => ({
                                original: getRessouresUrl()+img,
                                thumbnail: getRessouresUrl()+img,
                                originalHeight: 420,
                                thumbnailHeight: 30,
                            }))}
                            showNav={true}
                            showThumbnails={publication.publicationImages.length > 1}
                            showFullscreenButton={false}
                            showPlayButton={false}
                            autoPlay={false}
                        />
                    </>
                    : null
                }
            </div>
            <div className="buttons-container">
                <PublicationModal   id={publication._id}
                                    loadAll={props.loadAll}
                                    publication={publication}
                                    action="edit" />

                <PublicationModal   id={publication._id}
                                    loadAll={props.loadAll}
                                    publication={publication}
                                    action="remove" />
            </div>
        </div>);

};

export default memo(PublicationCard);
